import React, { useCallback, useState } from 'react';
import { getGridSingleSelectOperators } from '@mui/x-data-grid';
import { LayoutAdminTable } from 'app/components/templates/LayoutAdminTable';
import { TabsCustom } from 'app/components/elements/TabsCutom';
import { headerTab, TAB, useInjection } from './hook';
import { HeaderFileMemo } from './components/HeaderFile';
import { GridPaginationModel, GridRenderCellParams } from '@mui/x-data-grid';
import { Helmet } from 'react-helmet-async';
import { StatusFiles, StatusRedemptions } from 'const/option';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography
} from '@mui/material';
import { capitalizeFirstLetter } from 'const/common';
import { DispatchFile, Lead } from 'types/user';
import dayjs from 'dayjs';
import { saveVideoFile } from 'utils/downloadFile';
import { StorageServices } from 'services/storage';
import { SIZE_PAGE_CONTROL_PANEL } from 'const/paging';
import { DataTable } from '../../../components/elements/TableCustom';
import { ClientOption } from './components/FileForm/hook';
import { ButtonCustom } from '../../../components/elements/ButtonCustom';

const API_URL = process.env.REACT_APP_API_URL;
const storage = new StorageServices();
const renderHeader = ({
  tab,
  optionClient,
  optionsUser
}: {
  tab: string;
  optionsUser: { value: string; label: string }[];
  optionClient: ClientOption[];
}) => {
  const optionStatus =
    tab === TAB.REDEMPTION
      ? ['PRE_SEIZURE', 'POST_SEIZURE']
      : ['NEW', 'ATTENTION', 'WORKING', 'AGED'];
  return [
    {
      field: 'flag',
      headerName: '',
      width: 40,
      sortable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Stack
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              height: '100%'
            }}
            gap={1}>
            {!!params?.row?.leads?.find((item: Lead) => item.flag) && (
              <Stack style={{ width: 20, height: 20, borderRadius: 20, background: 'red' }} />
            )}
          </Stack>
        );
      }
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      width: 160,
      sortable: true,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        const date = new Date(params.value);
        return (
          <Stack
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              height: '100%'
            }}
            gap={1}>
            <Typography
              style={{
                color: '#22374A',
                fontSize: '14px'
              }}>
              {dayjs(date).format('YYYY-MM-DD HH:mm')}
            </Typography>
          </Stack>
        );
      }
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 180,
      sortable: false,
      filterable: true,
      type: 'singleSelect',
      valueOptions: optionStatus,
      filterOperators: getGridSingleSelectOperators().filter((operator) => {
        return operator.value !== 'not';
      }),
      renderCell: (params: GridRenderCellParams) => {
        const statusFile = params?.row?.fileStatusTransition?.status;
        const statusOpen = params?.value;
        let findStatus;
        if (statusFile === 'OPENED') {
          findStatus = StatusFiles.find((item) => item.value === statusOpen);
        } else {
          findStatus = StatusRedemptions.find((item) => item.value === statusFile);
        }
        return (
          <Stack
            style={{
              justifyContent: 'flex-start',
              alignItems: 'center',
              height: '100%',
              flexDirection: 'row',
              gap: 10
            }}>
            <Stack
              style={{
                background: findStatus?.color || '#9747FF',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0px 10px',
                height: '20px',
                borderRadius: '5px'
              }}>
              <Typography
                style={{
                  color: '#fff',
                  fontSize: '10px',
                  fontWeight: 600
                }}>
                {capitalizeFirstLetter(findStatus?.value.replace('_', ' ') || 'New')}
              </Typography>
            </Stack>
            {params.row.isFileReopen && (
              <Stack
                style={{
                  background: params.row.isFileReopen ? '#FF4773' : 'blue',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0px 10px',
                  height: '20px',
                  borderRadius: '5px'
                }}>
                <Typography
                  style={{
                    color: '#fff',
                    fontSize: '10px',
                    fontWeight: 600
                  }}>
                  Reopened
                </Typography>
              </Stack>
            )}
          </Stack>
        );
      }
    },

    {
      field: 'dispatchFiles',
      headerName: 'Agent Assigned to File',
      width: 200,
      sortable: false,
      filterable: true,
      type: 'singleSelect',
      valueOptions: optionsUser,
      filterOperators: getGridSingleSelectOperators().filter(
        (operator) => operator.value !== 'not'
      ),
      renderCell: (params: GridRenderCellParams) => {
        const listUser: DispatchFile[] = params.value;
        return (
          <Stack
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              height: '100%'
            }}
            gap={1}>
            <Typography
              style={{
                color: '#22374A',
                fontSize: '14px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%'
              }}>
              {listUser.map((item, index) => {
                return `${item?.user?.firstName} ${item?.user?.lastName} ${index === listUser.length - 1 ? '' : ', '}`;
              })}
            </Typography>
          </Stack>
        );
      }
    },
    {
      field: 'firstName',
      headerName: 'First Name',
      width: 160,
      sortable: false,
      filterable: false
    },
    { field: 'lastName', headerName: 'Last Name', width: 160, sortable: false, filterable: false },
    { field: 'year', headerName: 'Year', width: 100, sortable: false, filterable: false },
    { field: 'make', headerName: 'Make', width: 100, sortable: false, filterable: false },
    { field: 'model', headerName: 'Model', width: 100, sortable: false, filterable: false },
    { field: 'vin', headerName: 'VIN', width: 100, sortable: false, filterable: false },
    {
      field: 'clientOption',
      headerName: 'Client',
      width: 100,
      sortable: false,
      filterable: true,
      type: 'singleSelect',
      valueOptions: optionClient
        ?.filter((il) => !il.parentId)
        .map((item) => ({ label: item.value, value: item.id })),
      filterOperators: getGridSingleSelectOperators().filter(
        (operator) => operator.value !== 'not'
      ),
      renderCell: (params: GridRenderCellParams) => {
        const value = params.value?.parent?.value || params?.value?.value;
        return (
          <Stack
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              height: '100%'
            }}
            gap={1}>
            <Typography
              style={{
                color: '#22374A',
                fontSize: '14px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%'
              }}>
              {value}
            </Typography>
          </Stack>
        );
      }
    },
    { field: 'plate', headerName: 'Plate', width: 100, sortable: false, filterable: false },
    {
      field: 'fileNumber',
      headerName: 'File Number',
      width: 160,
      sortable: false,
      filterable: false
    },
    { field: 'quickNote', headerName: 'Quick Note', width: 160, sortable: false, filterable: false }
  ];
};
function FilePage() {
  const {
    tab,
    handleChangeTab,
    optionHeader,
    searchParams,
    fileStates,
    queryParams,
    handleRowClick,
    loading,
    handlePaginationModelChange,
    handleSearch,
    showValueSearch,
    handleSortModelChange,
    handleFilterModelChange,
    optionsUser,
    optionClient
  } = useInjection();

  const [openConfirm, setOpenConfirm] = useState(false);
  const [openConfirmMVS, setOpenConfirmMVS] = useState(false);

  const renderTab = useCallback(() => {
    const tab = searchParams.get('tab') || TAB.OPEN_FILES;
    const { files, total } = fileStates[tab];
    return (
      <Stack>
        <DataTable
          isFilter
          isSort
          data={files}
          totalRows={total}
          paginationModel={{
            page: (queryParams[tab]?.page || 1) - 1,
            pageSize: SIZE_PAGE_CONTROL_PANEL
          }}
          loading={loading}
          handlePaginationModelChange={(newPaginationModel: GridPaginationModel) =>
            handlePaginationModelChange(newPaginationModel, tab || TAB.REDEMPTION)
          }
          handleRowClick={handleRowClick}
          header={renderHeader({ tab, optionsUser, optionClient })}
          onSortModelChange={(model) => handleSortModelChange(model, tab)}
          onFilterModelChange={(model) => handleFilterModelChange(model, tab)}
        />
      </Stack>
    );
  }, [
    searchParams,
    fileStates,
    queryParams,
    loading,
    handleRowClick,
    optionsUser,
    optionClient,
    handlePaginationModelChange,
    handleSortModelChange,
    handleFilterModelChange
  ]);

  return (
    <LayoutAdminTable
      onSearch={handleSearch}
      search={showValueSearch}
      title={'File Overview'}
      element={
        !searchParams.get('tab') || searchParams.get('tab') === TAB.OPEN_FILES ? (
          <Stack flexDirection={'row'} gap={'10px'} width={'440px'}>
            <ButtonCustom
              style={{ padding: '12px 24px', width: 220 }}
              onClick={() => setOpenConfirmMVS(true)}
              label={'Export MVS'}
            />

            <ButtonCustom
              style={{ padding: '12px 24px', width: 220 }}
              onClick={() => setOpenConfirm(true)}
              label={'Export File Tow Yards'}
            />
          </Stack>
        ) : (
          <></>
        )
      }>
      <Dialog open={openConfirmMVS} onClose={() => setOpenConfirmMVS(false)}>
        <DialogTitle>Confirm Export</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to export MVS?</DialogContentText>{' '}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmMVS(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              const token = storage.getAccessToken();
              if (!token) return;
              await saveVideoFile(
                {
                  url: `${API_URL}/files/export/mvs-requested`,
                  fileName: `MVS_Requested_Export_${new Date().toISOString()}.xlsx`
                },
                token
              );
              setOpenConfirmMVS(false);
            }}
            color="secondary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirm Export</DialogTitle>
        <DialogContent>
          <DialogContentText>
            If you export, all Tow Yard Leads will be ruled out. Are you sure you want to continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              const token = storage.getAccessToken();
              if (!token) return;
              await saveVideoFile(
                {
                  url: `${API_URL}/files/export/towyards`,
                  fileName: `TowYard_Export_${new Date().toISOString()}.xlsx`
                },
                token
              );
              setOpenConfirm(false);
            }}
            color="secondary">
            Confirm Export
          </Button>
        </DialogActions>
      </Dialog>
      <Helmet>
        <title>Surrey Bailiffs - File Overview</title>
      </Helmet>
      <HeaderFileMemo optionHeader={optionHeader} />
      <TabsCustom
        tab={tab}
        contentTab={renderTab()}
        headerTab={headerTab}
        onChangeTab={handleChangeTab}
      />
    </LayoutAdminTable>
  );
}

export default FilePage;
